const waitForReCharge = () => {
  // Select the node that will be observed for mutations
  const targetNode = document.getElementById("rc_autodeliver_options");

  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = function (mutationList, observer) {
    // Use traditional 'for loops' for IE 11
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        let optionsContainer = document.getElementById(
          "rc_shipping_interval_frequency_chosen"
        );
        if (optionsContainer) {
          initSubscriptionOptionsDrop(optionsContainer);
          observer.disconnect();
        }
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
};

const initSubscriptionOptionsDrop = (containerEl) => {
  if (containerEl) {
    containerEl
      .querySelector(".chosen-single")
      .addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
  }
};

const initPDP = () => {
  console.log("init pdp!");
  waitForReCharge();
};

// initPDP();

// chosen-container chosen-container-single chosen-container-active chosen-with-drop
